export const DUPLICATE = "DUPLICATE";
export const INFORMATION_PROBLEM = "INFORMATION_PROBLEM";
export const OTHER = "OTHER";
